import { AnchoredPanel, AnchoredPanelType, ButtonType, FormattedString } from "o4a-react";
import * as React from "react";
import { Icon, Link } from "@fluentui/react";
import * as Messages from "../../codegen/Messages";

export interface InstructionsPanelProps {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
}

type ODSARolesInstructionPanelProps = Omit<InstructionsPanelProps, "title" | "children">;
type LinkSubscriptionInstructionPanelProps = Omit<InstructionsPanelProps, "title" | "children">;

export const InstructionsPanel = ({
  title,
  children,
  onClose,
}: InstructionsPanelProps): JSX.Element => (
  <AnchoredPanel
    anchorId="main"
    isOpen
    type={AnchoredPanelType.MEDIUM}
    title={title}
    onClose={onClose}
    footer={[
      {
        type: ButtonType.DEFAULT,
        label: Messages.actions.close(),
        onClick: onClose,
        style: { margin: "10px 5px 0px 0px", height: "24px" },
      },
    ]}
  >
    {children}
  </AnchoredPanel>
);

export const CloudLinkAdminInstructionsPanel = (props: ODSARolesInstructionPanelProps): JSX.Element => (
  <InstructionsPanel
    {...props}
    title={Messages.instructions.linkSubscriptions.title(Messages.portalBrand.short())}
  >
    <div>
      <ol>
        <li><FormattedString inputText={Messages.instructions.linkSubscriptions.step1()} /></li>
        <li><FormattedString inputText={Messages.instructions.linkSubscriptions.step2()} /></li>
        <li><FormattedString inputText={Messages.instructions.linkSubscriptions.step3()} /></li>
        <li><FormattedString inputText={Messages.instructions.linkSubscriptions.step4()} /></li>
        <li><FormattedString inputText={Messages.instructions.linkSubscriptions.step5()} /></li>
        <li><FormattedString inputText={Messages.instructions.linkSubscriptions.step6()} /></li>
        <li><FormattedString inputText={Messages.instructions.linkSubscriptions.step7()} /></li>
        <li><FormattedString inputText={Messages.instructions.linkSubscriptions.step8()} /></li>
        <li><FormattedString inputText={Messages.instructions.linkSubscriptions.step9()} /></li>
        <li><FormattedString inputText={Messages.instructions.linkSubscriptions.step10()} /></li>
        <li><FormattedString inputText={Messages.instructions.linkSubscriptions.step11()} /></li>
        <li>
          <FormattedString inputText={Messages.instructions.linkSubscriptions.step12(Messages.portalBrand.short())} />
        </li>
      </ol>
    </div>
    <div>
      <Link
        // eslint-disable-next-line max-len
        href="https://portal.azure.com/#view/Microsoft_AAD_IAM/StartboardApplicationsMenuBlade/~/AppAppsPreview/menuId~/null"
        target="_blank"
      >
        <span>{Messages.instructions.linkSubscriptions.azureLinkLabel()}</span>
        <span style={{ marginLeft: "8px" }}><Icon iconName="OpenInNewWindow" /></span>
      </Link>
    </div>
  </InstructionsPanel>
);

export const ListSubscriptionsInstructionsPanel = (props: LinkSubscriptionInstructionPanelProps): JSX.Element => (
  <InstructionsPanel
    {...props}
    title={Messages.instructions.assignRoles.title(Messages.portalBrand.short())}
  >
    <div>
      <ol>
        <li><FormattedString inputText={Messages.instructions.assignRoles.step1()} /></li>
        <li><FormattedString inputText={Messages.instructions.assignRoles.step2()} /></li>
        <li><FormattedString inputText={Messages.instructions.assignRoles.step3()} /></li>
        <li><FormattedString inputText={Messages.instructions.assignRoles.step3b()} /></li>
        <li><FormattedString inputText={Messages.instructions.assignRoles.step4()} /></li>
        <li><FormattedString inputText={Messages.instructions.assignRoles.step5()} /></li>
        <li><FormattedString inputText={Messages.instructions.assignRoles.step6()} /></li>
        <li><FormattedString inputText={Messages.instructions.assignRoles.step7()} /></li>
        <li><FormattedString inputText={Messages.instructions.assignRoles.step8()} /></li>
        <li><FormattedString inputText={Messages.instructions.assignRoles.step9()} /></li>
        <li><FormattedString inputText={Messages.instructions.assignRoles.step10()} /></li>
        <li><FormattedString inputText={Messages.instructions.assignRoles.step11()} /></li>
        <li><FormattedString inputText={Messages.instructions.assignRoles.step12()} /></li>
        <li><FormattedString inputText={Messages.instructions.assignRoles.step13()} /></li>
        <li><FormattedString inputText={Messages.instructions.assignRoles.step14()} /></li>
        <li><FormattedString inputText={Messages.instructions.assignRoles.step15()} /></li>
        <li><FormattedString inputText={Messages.instructions.assignRoles.step16()} /></li>
        <li><FormattedString inputText={Messages.instructions.assignRoles.step17()} /></li>
        <li><FormattedString inputText={Messages.instructions.assignRoles.step18()} /></li>
        <li><FormattedString inputText={Messages.instructions.assignRoles.step19()} /></li>
        <li><FormattedString inputText={Messages.instructions.assignRoles.step20()} /></li>
        <li><FormattedString inputText={Messages.instructions.assignRoles.step21()} /></li>
      </ol>
    </div>
    <div>
      <p>
        <FormattedString inputText={Messages.instructions.assignRoles.importantNote(Messages.portalBrand.short())} />
      </p>
    </div>
    <div>
      <Link
        href="https://portal.azure.com/#view/Microsoft_Azure_Billing/SubscriptionsBlade"
        target="_blank"
      >
        <span>{Messages.instructions.assignRoles.azureLinkLabel()}</span>
        <span style={{ marginLeft: "8px" }}><Icon iconName="OpenInNewWindow" /></span>
      </Link>
    </div>
  </InstructionsPanel>
);
